<template>
  <div>
    <v-dialog v-model="jobSelectDialog" max-width="500px" min-height="600">
      <v-card>
        <v-card-title primary-title>
          Select Your Job Site
        </v-card-title>
        <v-card-text>
          <job-selector
            @jobSiteChange="selectedJobSite = $event"
            :noAsbestosFilter="$route.path === '/daily-reports' ? false : true"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="jobSelectDialog = false" class="mr-2">
            cancel
          </v-btn>
          <v-btn
            color="primary"
            @click="goTo(selectedJobSite.id)"
            :disabled="!selectedJobSite"
          >
            Select job Site
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card>
      <v-simple-table v-if="myJobSites.length">
        <template v-slot:default>
          <tbody>
            <tr v-for="job in myJobSites" :key="job.id">
              <td>
                <strong>{{ job.street }} {{ job.street2 }}</strong
                ><br />
                <span class="caption">{{ job.jobId }}</span>
              </td>
              <td class="text-right">
                <v-btn color="primary" @click="goTo(job.id)"
                  >select job site</v-btn
                >
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <p v-else class="pa-4">
        You have no assigned job sites.
      </p>
    </v-card>
    <p class="pa-2 mt-4">
      Don't see the job listed?
      <v-btn
        rounded
        outlined
        text
        x-small
        class="ml-2"
        @click="jobSelectDialog = true"
        >Click here to Select Job</v-btn
      >
    </p>
  </div>
</template>

<script>
// import fb from "@/main";
import moment from "moment";
import { mapState } from "vuex";
import JobSelector from "../components/JobSelector";
export default {
  components: {
    JobSelector,
  },
  data() {
    return {
      jobs: [],
      jobSelectDialog: false,
      selectedJobSite: null,
    };
  },
  computed: {
    myJobSites: function() {
      return this.jobSites.filter(
        (job) =>
          job.assignedForeman &&
          job.assignedForeman.some((j) => this.user.uid === j.id)
      );
    },
    ...mapState(["user", "jobSites"]),
  },
  async created() {},
  methods: {
    today() {
      return moment().format("YYYY-MM-DD");
    },
    goTo(jobSiteId) {
      const path = this.$route.fullPath;
      if (path === "/daily-reports") {
        this.$router.push(`/daily-reports/${jobSiteId}/${this.today()}`);
      } else if (path === "/punch-dashboard") {
        this.$router.push(`/punch-in-out/${jobSiteId}`);
      }
    },
  },
};
</script>
